'use client'

import { createContext, useCallback, useContext, useState } from 'react'

const SearchStateContext = createContext({
  open: false,
  toggle: () => {},
  close: () => {},
})

export function SearchStateProvider({ children }) {
  const [open, setOpen] = useState(false)
  const toggle = useCallback(() => setOpen((v) => !v), [])
  const close = useCallback(() => setOpen(false), [])

  return <SearchStateContext.Provider value={{ open, toggle, close }}>{children}</SearchStateContext.Provider>
}

export function useSearchState() {
  return useContext(SearchStateContext)
}
